'use client'
import React, { useEffect, useRef, useState } from 'react'
import Article from '../article'
import { isBottomReached } from '@/shared/utils'
import { useLazyQuery } from '@apollo/client'
import { GET_NEXT_ARTICLE } from '@/graphql/article/article.query'
import Loading from '../loading'
import reviveAdsData from '@/shared/revive-ads/adsData.json'
import ReviveAds from '@/shared/revive-ads'

function InfiniteScrollArticle({ articleData }: any) {
  const [articles, setArticles] = useState<any>([])
  const articleRefs = useRef<any>([])
  const loading = useRef(false)
  const [isLoading, setIsLoading] = useState(false)

  const payload = useRef({
    iArticleId: articleData?._id,
    iCategoryId: articleData?.oCategory?._id,
    nSkip: 1
  })

  useEffect(() => {
    setArticles([articleData])
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 100)
  }, [])

  const [getNextArticleData, { data: newArticleData }] = useLazyQuery(GET_NEXT_ARTICLE)

  useEffect(() => {
    loading.current = false
    setIsLoading(false)
    if (articles?.length) isBottomReached(articles[articles.length - 1]?._id, isReached)
  }, [articles])

  async function isReached(reach: any) {
    if (reach) {
      setIsLoading(true)
      loading.current = true
      setPayload()
      getNewData()
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const currentArticleId = entry.target.id
            const currentArticle = articles.find(
              (article: any) => article?._id === currentArticleId
            )
            if (currentArticle) {
              const newPath = `/${currentArticle?.oSeo?.sSlug}`
              window.history.replaceState(null, '', newPath)
            }
          }
        })
      },
      { threshold: 0.2 }
    )

    articleRefs.current.forEach((ref: any) => {
      if (ref instanceof Element) {
        observer.unobserve(ref)
      }
    })

    articleRefs.current = articles.map(
      (_: any, i: any) => articleRefs.current[i] ?? document.createElement('div')
    )

    articleRefs.current.forEach((ref: any) => {
      if (ref instanceof Element) {
        observer.observe(ref)
      }
    })

    return () => {
      articleRefs.current.forEach((ref: any) => {
        if (ref instanceof Element) {
          observer.unobserve(ref)
        }
      })
    }
  }, [articles])

  useEffect(() => {
    const data = newArticleData?.getNextArticleFront
    if (data) {
      setArticles((pre: any) => [...pre, data])
    }
  }, [newArticleData])

  function setPayload() {
    payload.current = { ...payload.current, nSkip: payload.current.nSkip + 1 }
  }

  async function getNewData() {
    const newPayload = { ...payload.current }
    const { data } = await getNextArticleData({
      variables: { input: { ...newPayload } }
    })
    return data?.getNextArticleFront
  }

  return articles?.map((a: any, index: number) => {
    const { mobSm } = reviveAdsData.data
    return (
      <>
        <div
          id={a?._id}
          key={a?.id}
          className="border-b-2 border-dashed border-tabBorder pb-6 mb-6"
          ref={el => {
            articleRefs.current[index] = el
          }}
        >
          <Article article={a} />
          <div className="md:hidden flex justify-center mb-2">
            <ReviveAds {...mobSm} />
          </div>
        </div>
        {isLoading && <Loading />}
      </>
    )
  })
}

export default InfiniteScrollArticle
